import React, { Fragment, useState, useContext, useEffect } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import {
  IconWrapper,
  TextWrapper,
  ValueWrapper,
  VerticalSeparator,
  Row,
  HorizontalSeparator,
} from "./styled/Legend.styled";
import { VscRadioTower } from "react-icons/vsc";
import tinygradient from "tinygradient";
import IconButton from "@mui/material/IconButton";
import { WebMapContext } from "../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../pages/sections/web-map/LoadWebMap";
import { LightTooltip } from "./styled/LightTooltip.styled";

const iconMapper = {
  tower: (color) => (
    <VscRadioTower style={{ fontSize: "28px", color: `${color}` }} />
  ),
};

export default function Legend({ showLegend, legendData = [], LegendMinimized }) {
  const { mapPlacement } = useContext(WebMapContext);
  const { mapView } = useContext(LoadMapContext);
  const [isLegendMinimized, setIsLegendMinimized] = useState(false);
  useEffect(() => {
    setIsLegendMinimized(mapView === null ? isLegendMinimized : true);
  }, [mapView]);

  useEffect(() => {
    LegendMinimized(isLegendMinimized)
  }, [isLegendMinimized]);

  return (
    <Fragment>
      {showLegend && (
        <>
          {isLegendMinimized ? (
            <Grid
              container item
              style={{
                position: "fixed",
                bottom: "30px",
                ...(mapView === null
                  ? {
                    bottom: "60px",
                    right: "14px"
                  } : mapPlacement === 'right'
                    ? { right: '35px' }
                    : { left: '35px' }),
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #006F35",
                borderRadius: "10px",
                opacity: 0.8,
                width: "34px",
                height: "34px",
                alignItems: "center",
              }}
            >
              <IconButton onClick={() => { setIsLegendMinimized(false); }} >
                <img src={"/assets/legend-maximize.png"} width="16px" height="16px" alt={"legend-maximize"} />
              </IconButton>
            </Grid>
          ) : (
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                ...(mapView === null
                  ? {
                    bottom: "10px",
                    right: "10px"
                  } : mapPlacement === 'right'
                    ? { right: '35px' }
                    : { left: '35px' }),
                width: "auto",
                height: "auto",
                maxWidth: "445px",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #006F35",
                borderRadius: "10px",
                opacity: 1,
                font: "normal normal 600 10px/12px Open Sans",
                letterSpacing: "0px",
                color: "#707070",
                padding: "0px 5px",
                minHeight: "64px",
                paddingBottom: "10px",
                zIndex: 1
              }}
            >
              <Row style={{ position: "relative", display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "-30px" }}>
                <IconButton onClick={() => { setIsLegendMinimized(true); }} >
                  <img src={"/assets/legend-minimize.png"} width="16px" height="16px" alt={"legend-minimize"} />
                </IconButton>
              </Row>
              {legendData.map((legend, legendIdx) => {
                const {
                  title,
                  values = [],
                  boldTitle = false,
                  hideSeperator = false,
                  gradient = {},
                  notPermitted
                } = legend;
                const lastValueIndex = values.length - 1;
                return (
                  <Fragment key={legendIdx}>
                    {title && <Row bold={boldTitle} style={{ width: "80%", height: "24px", position: "relative", justifyContent: "space-between", marginBottom: "-5px" }}>{title}
                    </Row>}
                    <Row style={{ display: "flex", width: "100%", justifyContent: "flex-start", flexWrap: "wrap", alignItems: "flex-start" }}>
                      {values.map((item, key) => {
                        const {
                          markerType,
                          markerColor,
                          icon,
                          text,
                          img,
                          metaText,
                          imgWidth,
                          markerImg,
                          svg,
                        } = item;
                        return (
                          <Fragment>
                            {img ? (
                              <div style={{
                                width: "60px",
                                display: "flex",
                                justifyContent: "flex-start",
                                margin: "4px 0px 6px",
                                paddingLeft: "3px"
                              }}>
                                {markerType === "colorBox" ? (
                                  <IconWrapper ml={"0px"} color={markerColor} />
                                ) : <></>}
                                <div style={{
                                  width: "64%",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "1px solid #007842",
                                  borderRadius: "5px",
                                  margin: "0px 6px",
                                  padding: "2px"
                                }}>
                                  <img
                                    src={img}
                                    className="center"
                                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                                    height="auto"
                                    vertical-align="middle"
                                    alt={img}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div style={{ width: "46px", height: "40px", display: "flex", flexDirection: "column" }}>
                                <div style={{ width: "100%", display: "flex", justifyContent: "center", ...(markerType !== "colorBox" && { height: markerType === "image" ? "45%" : "40%" }) }}>
                                  {markerType === "colorBox" ? (
                                    <IconWrapper ml={"0px"} color={markerColor} />
                                  ) : markerType === "icon" ? (
                                    <>{iconMapper[icon](markerColor)}</>
                                  ) : svg ? svg
                                    : markerType === "image" ?
                                      <img
                                        src={markerImg}
                                        className="center"
                                        style={{ width: `${imgWidth}`, marginLeft: "5px" }}
                                        height="auto"
                                        vertical-align="middle"
                                        alt={markerImg}
                                      />
                                      : <></>}
                                </div>
                                <Box
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center"
                                  }}
                                >
                                  {text && (
                                    <TextWrapper>
                                      <LightTooltip
                                        PopperProps={{
                                          modifiers: [
                                            {
                                              name: "offset",
                                              options: {
                                                offset: [0, -10],
                                              },
                                            },
                                          ],
                                        }}
                                        title={text}>
                                        <div>
                                          <p style={{
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "38px",
                                            margin: markerType === "image" ? "2px 0 0" : "4px 0 0",
                                            ...(!metaText && {
                                              lineHeight: "10px"
                                            })
                                          }}>
                                            {markerType !== "colorBox" ? text : text.substring(0, text.indexOf(" "))}
                                          </p>
                                          {markerType === "colorBox" && <p style={{
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "38px",
                                            margin: "0px",
                                            ...(!metaText && {
                                              lineHeight: "10px"
                                            })
                                          }}>
                                            {text.substring(text.indexOf(" "))}
                                          </p>}
                                        </div>
                                      </LightTooltip>
                                      {metaText && (
                                        <ValueWrapper>
                                          {metaText}
                                        </ValueWrapper>
                                      )}
                                    </TextWrapper>
                                  )}
                                </Box>
                              </div>
                            )}
                            {key !== lastValueIndex && <VerticalSeparator />}
                          </Fragment>
                        );
                      })}
                      {
                        notPermitted && notPermitted?.isNotPermitted ?
                          <><VerticalSeparator /><div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "2px"
                          }}>
                            <IconWrapper ml={"0px"} color={'#B4B4B4'} />
                            <div style={{
                              height: "24px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "1px solid #007842",
                              borderRadius: "4px",
                              margin: "0px 6px",
                              padding: "4px"
                            }}>
                              <h4 style={{
                                textAlign: "center",
                                lineHeight: "8px",
                                font: "normal normal 600 8px/17px Open Sans",
                                color: "#707070",
                                opacity: 1
                              }}>{notPermitted.text}</h4>
                            </div>
                          </div></>
                          : <></>
                      }
                      {Object.keys(gradient).length > 0 && (
                        <div
                          style={{
                            backgroundImage: `${tinygradient(
                              gradient?.colors
                            ).css()}`,
                            width: "100%",
                            minWidth: "350px",
                            height: "16px",
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "12px"
                          }}
                        >
                          <p style={{ marginTop: "16px" }}>{gradient.min}</p>
                          <p style={{ marginTop: "16px" }}>{gradient.max}</p>
                        </div>
                      )}
                    </Row>
                    {legendIdx !== legendData.length - 1 && !hideSeperator && (
                      <HorizontalSeparator />
                    )}
                  </Fragment>
                );
              })}
            </div>)}
        </>
      )}
    </Fragment>
  );
}
